import { ReactNode } from "react";
import { X } from "lucide-react";

import { Button } from "../../ui/button";
import { LoadingSpinner } from "../../ui/loadingSpinner/loadingSpinner";
import { OPTRO_ACCESS_CHECKING_LABEL } from "../../../lib/optroAccessMessages";
import {
  OptroAccessKind,
  OptroViewAccess,
} from "../../../models/audit/optroAccess";
import { OptroAccessErrorPage } from "./OptroAccessErrorPage";

interface OptroAccessPanelGateProps {
  kind: OptroAccessKind;
  access: OptroViewAccess;
  onClose: () => void;
  children: ReactNode;
}

/**
 * The list pages' side-panel counterpart of `RequireOptroViewAccess`: the
 * panel renders only once `access` (from `useOptroViewAccess`, owned by the
 * page so it can also hold back the panel's sessions fetch) allows it. Until
 * then the panel is an empty shell with just a close button.
 */
export const OptroAccessPanelGate = ({
  kind,
  access,
  onClose,
  children,
}: OptroAccessPanelGateProps) => {
  if (access.state === "allowed") return <>{children}</>;

  return (
    <div className="flex h-screen flex-col overflow-y-auto border-l bg-white">
      <div className="flex justify-end border-b p-4">
        <Button variant="ghost" size="sm" onClick={onClose} aria-label="Close">
          <X className="h-4 w-4" />
        </Button>
      </div>
      {access.state === "checking" ? (
        <div className="flex justify-center py-12">
          <LoadingSpinner label={OPTRO_ACCESS_CHECKING_LABEL} />
        </div>
      ) : (
        <OptroAccessErrorPage
          kind={kind}
          failure={access.state}
          onRetry={access.retry}
          compact
        />
      )}
    </div>
  );
};
